// Viewport widths (the `sm` and `lg` breakpoints) between which `responiveFont`
// scales from its min to its max size.
const fluidFontMinWidth = 600;
const fluidFontMaxWidth = 1312;

/**
 * Max width of a default (`maxWidth="lg"`) Container: the 1312px content
 * column — four 310px cards with 24px gaps — plus its 24px gutters.
 */
export const contentMaxWidth = 1360;

/**
 * Max width of the floating bottom action bar: the 1312px content column plus
 * 40px a side, so content after the bar's 40px left inset lines up with the
 * column.
 */
export const stickyBarMaxWidth = 1392;

export function responiveFont(minSize: number, maxSize: number) {
  const base = 16;
  const x1 = fluidFontMinWidth;
  const x2 = fluidFontMaxWidth;
  // min rem fontsize
  const minRem = minSize / base;
  // max rem fontsize
  const maxRem = maxSize / base;

  const r = (x1 * maxSize - x2 * minSize) / (x1 - x2);
  const v = (100 * (maxSize - minSize)) / (x2 - x1);

  return {
    fontSize: `clamp(${minRem}rem, ${v}vw + ${r / base}rem, ${maxRem}rem)`,
  };
}

/**
 * The lower bound of a `responiveFont` clamp, read off a typography variant's
 * `fontSize`.
 */
export function pinToMinFontSize(
  fontSize: string | number | undefined
): string | number | undefined {
  if (typeof fontSize !== 'string') return fontSize;
  const min = /^\s*clamp\(([^,]+),/.exec(fontSize)?.[1];
  return min?.trim() ?? fontSize;
}
